// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-container{background:#fff;bottom:0;left:0;min-width:100%;outline:0;overflow:hidden;position:fixed;right:0;top:auto!important;z-index:1050}.popup-container button{width:100%}", ""]);
// Exports
module.exports = exports;
